



















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BvEvent } from 'bootstrap-vue';
import { companiesCollection, firebaseFunctions } from '@/firebaseConfig.ts';
import { Company } from '@/types';

@Component
export default class CompanyDetails extends Vue {
  company: Company | null = null;
  modFieldVal: string = '';
  newManagerEmail: string = '';
  newManagerPassword: string = '';
  managerFormError: string = '';
  isAddingMod: boolean = false;
  isSavingManager: boolean = false;
  companyId: string = '';

  async mounted() {
    this.companyId = this.$route.params.id;
    const docRef = await companiesCollection
      .doc(this.companyId)
      .onSnapshot(snapshot => {
        if (snapshot.exists) {
          const data = snapshot.data();
          console.log(data);
          this.company = data as Company;
        }
      });
  }

  async removeModerator(index: number) {
    const confirmation = await this.$bvModal.msgBoxConfirm(
      'This will permanently delete this moderator.',
      {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      },
    );
    if (confirmation && this.company) {
      const { mods } = this.company;
      mods.splice(index, 1);
      try {
        await this.updateModerators(mods);
      } catch (err) {
        console.log(err);
      }
    }
  }

  async updateModerators(mods: Array<string>) {
    await companiesCollection.doc(this.companyId).set(
      {
        mods: mods,
      },
      { merge: true },
    );
  }

  async addModerator() {
    if (this.company) {
      this.isAddingMod = true;
      const mods = this.company.mods || [];
      const newModVal: string = this.modFieldVal.trim();
      if (newModVal) {
        mods.push(newModVal);
        try {
          await this.updateModerators(mods);
          this.hideModal('addModeratorModal');
          this.company.mods = mods;
          this.modFieldVal = '';
        } catch (err) {
          console.log(err);
        }
      }
      this.isAddingMod = false;
    }
  }

  async updateManager() {
    if (!this.newManagerEmail.trim() && !this.newManagerPassword.trim()) return;
    const addManager = firebaseFunctions.httpsCallable('addCompanyManager');
    this.isSavingManager = true;
    this.managerFormError = '';
    await addManager({
      email: this.newManagerEmail,
      password: this.newManagerPassword,
      companyId: this.companyId,
    })
      .then(async () => {
        await companiesCollection.doc(this.companyId).set(
          {
            manager: this.newManagerEmail,
          },
          { merge: true },
        );
        this.hideModal('addManagerModal');
        this.newManagerEmail = '';
        this.newManagerPassword = '';
      })
      .catch(error => {
        console.log(error, error.message);
        this.managerFormError = error.message;
      })
      .finally(() => {
        this.isSavingManager = false;
      });
  }

  hideModal(modalId: string) {
    this.$bvModal.hide(modalId);
  }
}
